import React, { useState, useEffect } from 'react';
import { nodeUrls } from '../utils/nodeUrls';
import './styles.css';  // Import the CSS file from the same directory

const Ninfo = () => {
    const [data, setData] = useState({
        totalNdau: null,
        totalBurned: null,
        marketPrice: null,
        sib: null,
        tradingVolume: null,
        totalVotingPower: null,
        blockHeight: null,
        marketCap: null
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const primaryDataPromises = nodeUrls.map(baseUrl => fetch(baseUrl + 'price/current').then(response => response.json()));
                const [primaryData, volume, totalVotingPower, highestBlockHeight] = await Promise.all([
                    Promise.allSettled(primaryDataPromises),
                    fetchVolume(),
                    fetchTotalVotingPower(),
                    fetchHighestBlockHeight()
                ]);

                const validData = primaryData.find(result => result.status === 'fulfilled' && result.value.totalNdau);

                if (validData) {
                    const json = validData.value;
                    const marketCap = json.totalNdau / 100000000 * (json.marketPrice * 0.00000000001);
                    setData({
                        totalNdau: json.totalNdau / 100000000,
                        totalBurned: json.totalBurned / 100000000,
                        marketPrice: json.marketPrice * 0.00000000001,
                        sib: json.sib / 10000000000,
                        marketCap,
                        tradingVolume: volume,
                        totalVotingPower,
                        blockHeight: highestBlockHeight
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const fetchVolume = async () => {
        const apiUrl = "https://api-cloud.bitmart.com/spot/quotation/v3/ticker?symbol=NDAU_USDT";
        try {
            const response = await fetch(apiUrl);
            const data = await response.json();
            return Math.round(parseFloat(data.data.qv_24h)).toLocaleString() || 0;
        } catch (error) {
            console.error('Error fetching volume:', error);
            return 0;
        }
    };

    const fetchTotalVotingPower = async () => {
        for (const url of nodeUrls) {
            try {
                const response = await fetch(url + 'node/consensus');
                const data = await response.json();
                if (data && data.round_state && data.round_state.last_validators) {
                    const validators = data.round_state.last_validators.validators;
                    const totalPower = validators.reduce((acc, validator) => acc + parseInt(validator.voting_power, 10), 0);
                    console.log('Total voting power from first valid node:', totalPower);
                    return totalPower;
                }
            } catch (error) {
                console.error(`Error fetching voting power from ${url}:`, error);
            }
        }
        return 0; // Default to 0 if no valid data is found
    };

    const fetchHighestBlockHeight = async () => {
        try {
            const blockHeightPromises = nodeUrls.map(url =>
                fetch(url + 'block/height/')
                    .then(response => response.json())
                    .then(data => {
                        if (data && data.block_meta && data.block_meta.header) {
                            return data.block_meta.header.height;
                        }
                        return 0;
                    })
            );

            const blockHeights = await Promise.all(blockHeightPromises);
            return Math.max(...blockHeights);
        } catch (error) {
            console.error('Error fetching block height:', error);
            return 0;
        }
    };

    const formatValue = (value) => value !== null ? value.toLocaleString() : 'N/A';
    const formatIntegerValue = (value) => value !== null ? Math.round(value).toLocaleString() : 'N/A';

    return (
        <div className="dashboard-container">
            <h1>ndau Dashboard</h1>
            <div className="data-item"><span>Total Ndau:</span> <span className="value">{formatIntegerValue(data.totalNdau)}</span></div>
            <div className="data-item"><span>Burned:</span> <span className="value">{formatIntegerValue(data.totalBurned)}</span></div>
            <div className="data-item"><span>Price:</span> <span className="value">${data.marketPrice ? data.marketPrice.toFixed(2) : 'N/A'}</span></div>
            <div className="data-item"><span>Market Cap:</span> <span className="value">${formatIntegerValue(data.marketCap)}</span></div>
            <div className="data-item"><span>Trading Volume:</span> <span className="value">${data.tradingVolume ? data.tradingVolume : 'N/A'}</span></div>
            <div className="data-item"><span>SIB:</span> <span className="value">{data.sib ? `${data.sib.toFixed(2)}%` : 'N/A'}</span></div>
            <div className="data-item"><span>Total Voting Power:</span> <span className="value">{formatValue(data.totalVotingPower)}</span></div>
            <div className="data-item"><span>Block Height:</span> <span className="value">{formatValue(data.blockHeight)}</span></div>
        </div>
    );
};

export default Ninfo;
